import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const qrRequests = {}//Objeto agrupador de funciones

qrRequests.GetQrUid = (data) => {
    return axios.post(
      AppUrls.GetQrUid,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigNoAuth()
    ).then(handleResponse)
  }

  qrRequests.GetQrUidData = (data) => {
    return axios.post(
      AppUrls.GetQrUidData,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigNoAuth()
    ).then(handleResponse)
  }

  qrRequests.GetAssociatedFile = (data) => {
    return axios.post(
      AppUrls.GetAssociatedFile,
      Config.SetParameters(data, '', '', ''),
      Config.ConfigAuth()
    ).then(handleResponse)
  }

let handleResponse = (response) => {
    let respObject = response.data;
    if (!respObject.IsOK) {
      let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
      let error = (respObject.Body || responseObject);
      return Promise.reject(error);
    }
    return respObject;
  }